let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hdhCF")).then(() => parcelRequire('1LTrq'));